module.exports = __webpack_public_path__ + "static/water_optimos2-64788e36927c717847562f05c9c42e47.jpg";